import React, { useEffect, useState } from "react";
import { getschedule, getstoplist, mypass } from "../../services/Employeeservice";
import { getShiftListSearchApi } from "../../services/SearchService";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { changepass } from "../../services/Employeeservice";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaBus } from "react-icons/fa";
import { format } from "date-fns";
import { FaClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


const AvailableBusCard = ({ bus, isSelected, handleCardClick }) => {
  return (
    <div
      onClick={() => handleCardClick(bus.id)}
      style={{
        width: "120px",
        height: "120px",
        backgroundColor: isSelected
          ? "#5c3e20"
          : "#fdf2dc",
        color: isSelected ? "#fff" : "#000",
        border: isSelected
          ? "2px solid rgb(55, 38, 10)"
          : "2px solid transparent",
        borderRadius: "16px",
        boxShadow:
          "2px 2px 10px rgba(18, 13, 13, 0.1)",
        cursor: "pointer",
        transition: "all 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "12px",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          textTransform: "uppercase",
          marginBottom: "4px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center border-bottom">
          <span>🚌</span>
          <span className={`badge badge-lg ${isSelected ? 'bg-white text-primary' : 'bg-primary'}`}>{bus.route.route_number}</span>
        </div>
        <div>
          {bus.bus?.number_plate || "N/A"}
        </div>
      </div>
      <div
        style={{
          fontSize: "0.8rem",
          fontWeight: 500,
          color: isSelected ? "#e2e6ea" : "#6c757d",
        }}
      >
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "0.8rem",
          color: isSelected ? "#dee2e6" : "#495057",
        }}
      >
        <FaClock className="me-1" />
        {format(
          new Date(`1970-01-01T${bus.reach_time}`),
          "h:mm a"
        )}
      </div>
    </div>
  )
}

const Passchange = () => {
  const navigate = useNavigate();
  const [pass, setPass] = useState(null)
  const [shiftLoading, setShiftLoading] = useState(false);
  const [scheduleloading, setScheduleloading] = useState(false);
  const [submitloading, setSubmitloading] = useState(false);
  const [stops, setStops] = useState([]);
  const [selectedstop, setSelectedstop] = useState(null);
  const [shift, setShift] = useState([]);
  const [selectedShift, setSelectedShift] = useState(null);
  const [schedule, setSchedule] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    mypass()
      .then((res) => {
        setPass(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    getstoplist()
      .then((res) => {
        setStops(res.data);
      })
      .catch((error) => console.log(error));

    const getShiftList = () => {
      setShiftLoading(true);
      getShiftListSearchApi()
        .then((res) => {
          setShift(res.data);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setShiftLoading(false);
        });
    };
    getShiftList();
  }, []);

  const getschedules = (stopId, shiftId) => {
    setScheduleloading(true);
    getschedule(stopId, shiftId)
      .then((res) => {
        setSchedule(res?.data?.results);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setScheduleloading(false);
      });
  };

  const handleCardClick = (id) => {
    if (selectedId == id) {
      setSelectedId(null);
    } else {
      setSelectedId(id);
    }
  };

  const invalid = !(selectedId);

  const handlesubmit = () => {
    setSubmitloading(true);
    const payload = {
      stop_id: selectedstop?.value,
      shift_id: selectedShift?.value,
      schedule: selectedId,
    };

    setTimeout(() => {
      changepass(payload)
        .then((res) => {
          if (res.data) {
            handlereset();
            navigate("/dashboard");
            toast.success(res.data?.message || "Applied Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err?.response?.data?.message || "Something Went Wrong");
        });
      setSubmitloading(false);
    }, 1000);
  };

  const handlereset = () => {
    setSelectedstop(null);
    setSelectedShift(null);
    setSelectedId(null);
    setSchedule([]);
  };
  if (pass === null) {
    <div className="text-center m-1">
      <Spinner animation="border" size="sm" />
      <span className="ms-1">Loading...</span>
    </div>
  }
  
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <span
            className="text-primary"
            style={{ fontSize: "1.2rem", fontWeight: "500" }}
          >
            Change Pass
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Change Pass
            </li>
          </ol>
        </div>
      </div>
      <div className="row d-flex justify-content-center mt-4">
        <div className="col">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <div className="row">
                    <div className="col-12">
                      <label className="form-label">Select Current Stops</label>
                      <Select
                        className="react-select"
                        classNamePrefix="select"
                        options={stops}
                        onChange={(data) => {
                          setSelectedstop(data);
                          setSchedule([]);
                          setSelectedShift(null);
                        }}
                        value={selectedstop}
                      />
                    </div>
                    <div className="col-12 mt-1">
                      {shiftLoading ? (
                        <div className="text-center m-1">
                          <Spinner animation="border" size="sm" />
                          <span className="ms-1">Loading...</span>
                        </div>
                      ) : (
                        <>
                          <label className="form-label">Select Cuurent Shift</label>
                          <Select
                            className="react-select"
                            classNamePrefix="select"
                            options={shift}
                            onChange={(data) => {
                              setSelectedShift(data);
                              setSelectedId(null);
                              setSchedule([]);
                              getschedules(selectedstop?.value, data?.value);
                            }}
                            value={selectedShift}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="row">
                    <div className="col-12">
                      <span className="d-block text-center fs-5 fw-semibold text-primary">
                        <FaBus className="me-1" />
                        Available Buses
                      </span>

                      {
                        (selectedShift && selectedstop) ? scheduleloading ? (
                          <div className="text-center mt-5">
                            <Spinner animation="border" size="sm" />
                            <span className="ms-1">Featching Available buses...</span>
                          </div>
                        ) : schedule.filter((bus) => bus.bus?.capacity > 0)
                          .length > 0 ? (
                          <div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
                            {schedule
                              .filter((bus) => bus.bus?.capacity > 0)
                              .map((bus, index) => (
                                <AvailableBusCard
                                  key={index}
                                  bus={bus}
                                  isSelected={selectedId === bus.id}
                                  handleCardClick={handleCardClick}
                                />
                              )
                              )}
                          </div>
                        ) : (
                          <div className="alert alert-warning" role="alert">
                            <h4 className="alert-heading">
                              <i className="bi bi-exclamation-triangle-fill me-2"></i>
                              No Seats Available
                            </h4>
                            <p>
                              Unfortunately, there are no seats available for your selected stop and shift.
                            </p>
                            <hr />
                            <p className="mb-0">
                              <strong>To find a bus now,</strong> please try selecting a different
                              pickup stop or shift in the search area.
                            </p>
                            <div className="text-center my-3">
                              <strong className="text-primary">OR</strong>
                            </div>
                            <div>
                              <p>
                                <strong>Willing to wait?</strong> You can apply for a pass, and
                                we'll notify you when a seat becomes available.
                              </p>
                              <button className="btn btn-primary" onClick={handlesubmit}>
                                Apply for a Pass
                              </button>
                              <small className="d-block mt-2">
                                Your pass status will be 'pending' until a seat is confirmed.
                              </small>
                            </div>
                          </div>
                        ) : (
                          <p className="text-center text-secondary fw-medium mt-4 fs-6">
                            Please select first pickup Stop & Shift
                          </p>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {selectedId &&
              <div className="card-footer text-center">
                <button
                  className="btn btn-primary"
                  onClick={handlesubmit}
                  disabled={invalid || submitloading}
                >
                  {submitloading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span className="ms-1">Loading...</span>
                    </>
                  ) : (
                    "Apply"
                  )}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Passchange;
